package io.horion.auth.presentation.ui.styles

import com.varabyte.kobweb.compose.css.Cursor.Companion.Pointer
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.*

val PageWrapperStyle = CssStyle {
    base          { Modifier.fillMaxSize().padding(16.px) }
    Breakpoint.MD { Modifier.padding(32.px) }
    Breakpoint.LG { Modifier.padding(48.px) }
    Breakpoint.XL { Modifier.padding(64.px) }
}

val AuthContentStyle = CssStyle {
    base          { Modifier.width(100.percent) }
    Breakpoint.MD { Modifier.width(480.px) }
    Breakpoint.LG { Modifier.width(520.px) }
    Breakpoint.XL { Modifier.width(560.px) }
}

val ProfileContentStyle = CssStyle {
    base          { Modifier.width(100.percent) }
    Breakpoint.MD { Modifier.width(560.px) }
    Breakpoint.LG { Modifier.width(640.px) }
    Breakpoint.XL { Modifier.width(720.px) }
}

val AuthTitleStyle = CssStyle {
    base          { Modifier.fontSize(24.px) }
    Breakpoint.SM { Modifier.fontSize(28.px) }
    Breakpoint.MD { Modifier.fontSize(32.px) }
}

val AvatarStyle = CssStyle {
    base          { Modifier.size(100.px) }
    Breakpoint.SM { Modifier.size(110.px) }
    Breakpoint.MD { Modifier.size(120.px) }
}

val AvatarIconStyle = CssStyle {
    base          { Modifier.fontSize(40.px) }
    Breakpoint.SM { Modifier.fontSize(44.px) }
    Breakpoint.MD { Modifier.fontSize(48.px) }
}

val ProfileNameStyle = CssStyle {
    base          { Modifier.fontSize(22.px) }
    Breakpoint.SM { Modifier.fontSize(24.px) }
    Breakpoint.MD { Modifier.fontSize(28.px) }
}

val OtpBoxStyle = CssStyle {
    base          { Modifier.size(52.px, 64.px).margin(4.px) }
    Breakpoint.MD { Modifier.size(64.px, 80.px).margin(8.px) }
}

val BannerStyle = CssStyle {
    base          { Modifier.fillMaxWidth().padding(leftRight = 12.px, topBottom = 12.px) }
    Breakpoint.MD { Modifier.padding(leftRight = 24.px, topBottom = 12.px) }
}

val TopBarStyle = CssStyle {
    base          { Modifier.fillMaxWidth().padding(leftRight = 16.px, topBottom = 12.px) }
    Breakpoint.MD { Modifier.padding(leftRight = 32.px, topBottom = 16.px) }
    Breakpoint.LG { Modifier.padding(leftRight = 48.px, topBottom = 16.px) }
}

val LogoStyle = CssStyle {
    base          { Modifier.height(28.px) }
    Breakpoint.MD { Modifier.height(34.px) }
    Breakpoint.LG { Modifier.height(38.px) }
}

val ProfileLayoutStyle = CssStyle {
    // mobile : colonne empilée
    base          { Modifier.fillMaxSize().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column) }
    // ≥ MD : sidebar + contenu côte à côte
    Breakpoint.MD { Modifier.flexDirection(FlexDirection.Row) }
}

val ProfileSidebarStyle = CssStyle {
    base          { Modifier.width(100.percent).padding(16.px) }
    Breakpoint.MD { Modifier.width(240.px).minHeight(100.vh).padding(topBottom = 24.px, leftRight = 0.px) }
    Breakpoint.LG { Modifier.width(260.px) }
}

val ProfileMainStyle = CssStyle {
    base          { Modifier.fillMaxWidth().padding(16.px) }
    Breakpoint.MD { Modifier.padding(32.px) }
    Breakpoint.LG { Modifier.padding(40.px) }
}

val ProfileCardStyle = CssStyle {
    base          { Modifier.fillMaxWidth().padding(20.px).borderRadius(16.px) }
    Breakpoint.MD { Modifier.padding(28.px) }
}

val ProfileHeaderCardStyle = CssStyle {
    base          { Modifier.fillMaxWidth().padding(20.px).borderRadius(16.px) }
    Breakpoint.MD { Modifier.padding(28.px) }
}

val SidebarNavItemStyle = CssStyle {
    base { Modifier.fillMaxWidth().padding(leftRight = 16.px, topBottom = 12.px).borderRadius(10.px).cursor(Pointer) }
}

val ProfileAvatarContainerStyle = CssStyle {
    base          { Modifier.size(80.px) }
    Breakpoint.MD { Modifier.size(96.px) }
}

val ProfileAvatarIconSizeStyle = CssStyle {
    base          { Modifier.fontSize(32.px) }
    Breakpoint.MD { Modifier.fontSize(40.px) }
}

val ProfileGridStyle = CssStyle {
    base          { Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).gap(16.px) }
    Breakpoint.MD { Modifier.display(DisplayStyle.Grid).styleModifier { property("grid-template-columns", "1fr 1fr") }.gap(20.px) }
}

val SecurityRowStyle = CssStyle {
    base { Modifier.fillMaxWidth().padding(leftRight = 16.px, topBottom = 14.px).borderRadius(12.px).cursor(Pointer) }
}